import { Route, Redirect, Switch, useLocation } from "react-router-dom";
import React, { Suspense, Fragment, useState, useEffect } from "react";
import routes from "../../routes";
import litRoutes from "../../LIT/routes/litRoutes";
import { RouteLoader } from "../RouteLoader";
import { ToastContainer, toast } from 'react-toastify';
import Modal from "../../Pages/Components/Modal/Examples/Modal";
import Login from "../../Pages/Login";
import ForgotPassword from "../../Pages/ForgotPassword/ForgotPassword";
import CreateNewPassword from "../../Pages/CreateNewPassword/CreateNewPassword";
import Signup from "../../Pages/Signup/Signup";
import { logout } from "../../utils/utils";
import SockJsClient from "react-stomp";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { postTifMonitoringActionsControlStatus } from "../../store/actions/TifMonitoringAction";
import {
  RebootStbControlStatus,
  postFactoryResetEventsControlStatus,
  postAppKillEventsControlStatus,
  postAppClearDataEventsControlStatus,
  postAppClearCacheEventsControlStatus,
  postCaptureScreenShotEventControlStatus,
  postResetParentalPinEventControlStatus,
  postSilentLoginEventControlStatus,
  postAppGenerateLogsEventsControlStatus,
  postSignalStrengthQualityEventControlStatus,
  postPlayContentEventControlStatus,
  postUninstallAppsEventControlStatus,
  postKillAppsEventControlStatus,
  postUpdatePubnubEventControlStatus,
  postBugReportEventControlStatus,
  postDiagnosisCheckEventControlStatus
} from "../../store/actions/ControlEventsActions";
import { zapTimeFetchNowStatus, viewingTimeFetchNowStatus } from "../../store/actions/DurationActions";
import { cpuUsageFetchNowStatus, memoryUsageFetchNowStatus } from "../../store/actions/SystemUsageAction";
import { deviceStorageFetchNowStatus } from "../../store/actions/DeviceStorageAction";
import { postSatelliteScanSuccessControlStatus } from "../../store/actions/SatelliteScanAction";
import {
  globalControlStatus
} from "../../store/actions/StbInfoBySidAction";
import { satelliteSignalFetchNowStatus } from "../../store/actions/SatelliteSignalAction";
import { entitlementsFetchNowStatus } from "../../store/actions/EntitlementAction";
import { networkSpeedFetchNowStatus } from "../../store/actions/NetworkSpeedAction";
import { networkConditionsFetchNowStatus } from "../../store/actions/NetworkConditionsAction";
import { appsFetchNowStatus } from "../../store/actions/AppsInstalledAction";
import { systemDetailsFetchNowStatus } from "../../store/actions/SystemDetailsAction";
import { batteryStatusFetchNowStatus } from "../../store/actions/BatteryStatusAction";
import { tifMonitoringFetchNowStatus } from "../../store/actions/TifMonitoringAction";
import { bluetoothDevicesFetchNowStatus } from "../../store/actions/BluetoothDeviceAction";
import { androidSettingsFetchNowStatus } from "../../store/actions/AndroidSettingsAction";
import { myRecordsFetchNowStatus } from "../../store/actions/MyRecordsAction";
import { systemDetailsAdbStatus } from "../../store/actions/SystemDetailsAction";
import { wizardControlRequestReceivedStatus, wizardControlRequestProcessedStatus } from "../../store/actions/WizardSIDLevelActions";
import { callAccedoAPI } from "../../axios/accedoApi";
import {callAPI} from "../../axios/index";
import {
  litAccountRefreshControlStatus,
  litAppLogoutControlStatus,
  litClearCacheControlStatus,
} from "../../LIT/store/actions/litControlActions";
import PageNotFound from "../PageNotFound/PageNotFound";
import { clearCrashFilterQueryPayLoads, CRASH_FILTER_QUERY_PAYLOAD_EXPIRY_TIME } from "../../Pages/TotalLauncherCrash/crashFilterQueryStorage";
import { getProjectForPath } from "../../constants/workspaceConfig";

const LIT_ACTION_LABELS = {
  accountRefresh: "Account Refresh",
  appLogout: "App Logout",
  clearCache: "Clear Cache",
  logout: "App Logout",
};

const LIT_CONTROL_ACTIONS = ["logout", "clearCache", "accountRefresh"];

export const LitNotificationMessage = ({ webSocketMessage, statusDetails }) => {
  const requestedBy = webSocketMessage.userName || webSocketMessage.userId;

  return (
    <div>
      <h5 className={`d-flex justify-content-center ${statusDetails.headingClass}`}>
        {statusDetails.title}
      </h5>
      <p className="mb-1"><strong>Action:</strong> {LIT_ACTION_LABELS[webSocketMessage.action] || webSocketMessage.action}</p>
      {webSocketMessage.SID && (
        <p className="mb-1"><strong>Subscriber ID:</strong> {webSocketMessage.SID}</p>
      )}
      {webSocketMessage.deviceId && (
        <p className="mb-1"><strong>Device ID:</strong> {webSocketMessage.deviceId}</p>
      )}
      {requestedBy && (
        <p className="mb-1"><strong>Requested by:</strong> {requestedBy}</p>
      )}
      {webSocketMessage.controlRequestID && (
        <p className="mb-1"><strong>Request ID:</strong> {webSocketMessage.controlRequestID}</p>
      )}
      {statusDetails.failureMessage && <p className="mb-0">{statusDetails.failureMessage}</p>}
    </div>
  );
};

const AppMain = () => {
  const dispatch = useDispatch();
  const location = useLocation(); 
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorFlag429, setErrorFlag429] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  // const [webSocketPopup, setWebSocketPopup] = useState(false);
  // const [webSocketMessage, setWebSocketMessage] = useState(false);
  const isLoggedIn = localStorage.getItem("jwt_token");
  let localStorageUserId = JSON.parse(localStorage.getItem("user_id"));

  // Derive which project names the current user can access.
  const userProjectNames = (JSON.parse(localStorage.getItem("userProjects") || "[]"))
    .filter((p) => p.projectName)
    .map((p) => p.projectName);

  // Determine the project that owns the current path and whether the user has access.
  // null means a shared route (e.g. /UserManagement) — always accessible.
  const requiredProject = getProjectForPath(location.pathname);
  const canAccessRoute =
    requiredProject === null ||
    userProjectNames.length === 0 ||
    userProjectNames.includes(requiredProject);

  
  const notify = (webSocketMessage) => {
      if(webSocketMessage.status==="processed" && webSocketMessage.action==="resetPin"){
        callAPI("/sms","POST",{
          "mobileNumber": localStorage.getItem("RegisteredNumber"),
          "sid": webSocketMessage.SID,
          "cdsn": webSocketMessage.CDSN
        }).then((response) => {
          toast(response.message, {
            closeButton: true,
            autoClose: 6000,
            position: 'top-right',
            type: 'success'
          });
        })
        .catch((error) => {
          console.log(error.response?.data?.errorMessage)
        });
      }
      if(webSocketMessage.status==="processed"){
        toast(<div>
          <h5 className="d-flex justify-content-center text-success">Processed</h5>
          <p>{`${webSocketMessage.wizardInfo?"Wizard":""} Control Action ${webSocketMessage.action=="beacon"?"entitlement":webSocketMessage.action} for SID- ${webSocketMessage.SID} & CDSN- ${webSocketMessage.CDSN} requested by ${webSocketMessage.userName}`}</p>
          </div>, 
        {
          closeButton: true,
          autoClose: 6000,
          position: 'top-right',
          type: 'success'
        });
      }
      else if(webSocketMessage.status==="received"){
        toast(<div>
          <h5 className="d-flex justify-content-center text-info">Received</h5>
          <p>{`${webSocketMessage.wizardInfo?"Wizard":""} Control Action ${webSocketMessage.action=="beacon"?"entitlement":webSocketMessage.action} for SID- ${webSocketMessage.SID} & CDSN- ${webSocketMessage.CDSN} requested by ${webSocketMessage.userName}`}</p>
          </div>, 
        {
          closeButton: true,
          autoClose: 6000,
          position: 'top-right',
          type: 'info'
        });
      }
      else if(webSocketMessage.status==="failed_reception") {
        toast(<div>
          <h5 className="d-flex justify-content-center text-danger">Failed</h5>
          <p>{`${webSocketMessage.wizardInfo?"Wizard":""} Control Action ${webSocketMessage.action=="beacon"?"Entitlement":webSocketMessage?.action} for SID- ${webSocketMessage.SID} & CDSN- ${webSocketMessage.CDSN} requested by ${webSocketMessage.userName}. As box is not connected to Internet! please try again`}</p>
        </div>, {
          closeButton: true,
          autoClose: 6000,
          position: 'top-right',
          type: 'error'
        });
      }
      else {
        toast(<div>
          <h5 className="d-flex justify-content-center text-danger">Failed</h5>
          <p>{`${webSocketMessage.wizardInfo?"Wizard":""} Control Action ${webSocketMessage.action=="beacon"?"Entitlement":webSocketMessage?.action} for SID- ${webSocketMessage.SID} & CDSN- ${webSocketMessage.CDSN} requested by ${webSocketMessage.userName}. Please try again`}</p>
        </div>,
         {
          closeButton: true,
          autoClose: 6000,
          position: 'top-right',
          type: 'error'
        });
    }
  }

  const notifyLIT = (webSocketMessage) => {
    let statusDetails;

    if (webSocketMessage.status === "accepted") {
      statusDetails = {
        title: "Accepted",
        headingClass: "text-info",
        type: "info",
      };
    } else if (webSocketMessage.status === "processed") {
      statusDetails = {
        title: "Processed",
        headingClass: "text-success",
        type: "success",
      };
    } else if (webSocketMessage.status === "received") {
      statusDetails = {
        title: "Received",
        headingClass: "text-info",
        type: "info",
      };
    } else if (webSocketMessage.status === "failed_reception") {
      statusDetails = {
        title: "Failed",
        headingClass: "text-danger",
        type: "error",
        failureMessage: "The LIT device is not connected to the internet. Please try again.",
      };
    } else {
      statusDetails = {
        title: "Failed",
        headingClass: "text-danger",
        type: "error",
        failureMessage: webSocketMessage.error || "The control action failed. Please try again.",
      };
    }

    toast(
      <LitNotificationMessage
        webSocketMessage={webSocketMessage}
        statusDetails={statusDetails}
      />,
      {
        closeButton: true,
        autoClose: 6000,
        position: "top-right",
        type: statusDetails.type,
      }
    );
  };
  
  useEffect(() => {
    const handle401Error = (e) => {
      setErrorFlag(true);
      setApiMessage(e.detail);
    };
    const handleApiError = (e) => {
      setErrorFlag429(true);
      setApiMessage(e.detail);
    };

    window.addEventListener("401_Error", handle401Error);
    window.addEventListener("429_error", handleApiError);
    window.addEventListener("500_error", handleApiError);

    return () => {
      window.removeEventListener("401_Error", handle401Error);
      window.removeEventListener("429_error", handleApiError);
      window.removeEventListener("500_error", handleApiError);
    };
  }, []);
  // window.addEventListener("403_Error", (e)=>{
  //     setErrorFlag(true)
  //     setApiMessage(e.detail)
  //     })

  useEffect(() => {
    const intervalId = setInterval(() => {
      clearCrashFilterQueryPayLoads();
    }, CRASH_FILTER_QUERY_PAYLOAD_EXPIRY_TIME);
    return () => clearInterval(intervalId);
  },[])

  useEffect(() => {
    if(isLoggedIn){
    // if (localStorage.getItem("accedo_url") !== "https://d2jq06bpblikah.cloudfront.net/v1") {
    //   localStorage.setItem("accedo_url", "https://d2jq06bpblikah.cloudfront.net/v1");
    // }
    // if(JSON.parse(localStorage.getItem("AppLogoResponse"))?.version!=="2023.24.4-1.17.11 PM"){
    //   callAccedoAPI(`${localStorage.getItem("accedo_url")}/appLogo`, "GET").then(
    //     (res) =>localStorage.setItem("AppLogoResponse",JSON.stringify(res))
    //   ).catch(err =>console.log(err.message));
    // }
    const platform = getProjectForPath(location.pathname) === "LIT" ? "LIT" : "STB";
    const controlKey = platform === "LIT" ? "AppConfigControlResponseLIT" : "AppConfigControlResponse";
    const periodicKey = platform === "LIT" ? "AppConfigPeriodicResponseLIT" : "AppConfigPeriodicResponse";
    if(JSON.parse(localStorage.getItem(controlKey))?.body?.ConfigData?.version!=="2023.18.5-3.27.06 PM"){
      callAccedoAPI(`${localStorage.getItem("accedo_url")}/config?type=control&platform=${platform}`,"GET")
        .then((response) => localStorage.setItem(controlKey,JSON.stringify(response)))
        .catch((error) =>console.log(error));
    }
    if(platform !== "LIT" && JSON.parse(localStorage.getItem(periodicKey))?.body?.ConfigData?.version!=="2023.18.5-3.27.06 PM"){
      callAccedoAPI(`${localStorage.getItem("accedo_url")}/config?type=periodic&platform=${platform}`,"GET")
        .then((response) => localStorage.setItem(periodicKey,JSON.stringify(response)))
        .catch((error) =>console.log(error));
    }
  }
  },[]);
  
  const onSocketResponse = (data) => {
    if(isLoggedIn){
      if (data != undefined) {
        const activeProject =
          getProjectForPath(location.pathname) ||
          localStorage.getItem("workspace") ||
          "";
        const isLitControlAction = LIT_CONTROL_ACTIONS.includes(data.action);

        if (activeProject === "LIT") {
          if (!isLitControlAction) return;
          if (
            data.userName?.toLowerCase() !==
            localStorageUserId?.userName?.toLowerCase()
          ) return;

          if (data.action === "logout") {
            dispatch(litAppLogoutControlStatus(data));
          } else if (data.action === "clearCache") {
            dispatch(litClearCacheControlStatus(data));
          } else if (data.action === "accountRefresh") {
            dispatch(litAccountRefreshControlStatus(data));
          }
          setTimeout(() => {
            notifyLIT(data);
          }, 1000);
          return;
        } else if (!isLitControlAction && data.controlRequestID && data.action && data.status) {
          if((data.userName).toLowerCase() ===(localStorageUserId.userName).toLowerCase()){
            // console.log(data)
            const pageUrl= `/wizardStatus/${data.SID}/${data.CDSN}/${data?.wizardInfo?.wizardId}`
            if(data.status==="received" && data.wizardInfo){
              if(location.pathname.includes(pageUrl)){
                notify(data)
                dispatch(wizardControlRequestReceivedStatus(data))
              }
              else if(!location.pathname.includes("wizardStatus")){
                notify(data)
              }
            }else if ((data.status==="processed" || data.status==="failed") && data.wizardInfo){
              if(location.pathname.includes(pageUrl)){
                notify(data)
                dispatch(wizardControlRequestProcessedStatus(data))
              }
              else if(!location.pathname.includes("wizardStatus")){
                notify(data)
              }
            }
              setTimeout(()=>{
                if (data?.action === "rebuildEPGCache") {
                  dispatch(postTifMonitoringActionsControlStatus(data));
                } else if (data?.action === "satelliteSignalScan") {
                  dispatch(postSatelliteScanSuccessControlStatus(data));
                } else if (data?.action === "beacon") {
                  dispatch(entitlementsFetchNowStatus(data));
                } else if (data?.action === "appsInstalled") {
                  dispatch(appsFetchNowStatus(data));
                } else if (data?.action === "batteryStatus") {
                  dispatch(batteryStatusFetchNowStatus(data));
                } else if (data?.action === "networkSpeed") {
                  dispatch(networkSpeedFetchNowStatus(data));
                } else if (data?.action === "networkConditions") {
                  dispatch(networkConditionsFetchNowStatus(data));
                } else if (data?.action === "bluetoothDevices") {
                  dispatch(bluetoothDevicesFetchNowStatus(data));
                } else if (data?.action === "satelliteSignal") {
                  dispatch(satelliteSignalFetchNowStatus(data));
                } else if (data?.action === "systemDetails") {
                  dispatch(systemDetailsFetchNowStatus(data));
                } else if (data?.action === "tifStatus") {
                  dispatch(tifMonitoringFetchNowStatus(data));
                } else if (data?.action === "androidSettings") {
                  dispatch(androidSettingsFetchNowStatus(data));
                } else if (data?.action === "cdvrRecording") {
                  dispatch(myRecordsFetchNowStatus(data));
                } else if (data?.action === "rebootSTB") {
                  dispatch(RebootStbControlStatus(data));
                } else if (data?.action === "factoryReset") {
                  dispatch(postFactoryResetEventsControlStatus(data));
                } else if (data?.action === "killLauncherApp") {
                  dispatch(postAppKillEventsControlStatus(data));
                } else if (data?.action === "clearLauncherAppData" || data?.action === "clearThirdPartyData") {
                  dispatch(postAppClearDataEventsControlStatus(data));
                } else if (data?.action === "clearLauncherAppCache" || data?.action === "clearThirdPartyCache") {
                  dispatch(postAppClearCacheEventsControlStatus(data));
                } else if (data?.action === "captureScreenShot") {
                  dispatch(postCaptureScreenShotEventControlStatus(data));
                } else if (data?.action === "resetPin") {
                  dispatch(postResetParentalPinEventControlStatus(data));
                } else if (data?.action === "deviceLogCollection") {
                  dispatch(postAppGenerateLogsEventsControlStatus(data));
                } else if (data?.action === "silentLogin") {
                  dispatch(postSilentLoginEventControlStatus(data));
                } else if (data?.action === "pubnub") {
                  dispatch(postUpdatePubnubEventControlStatus(data));
                } else if (data?.action === "bugReport") {
                  dispatch(postBugReportEventControlStatus(data));
                } else if (data?.action === "diagnosisControl") {
                  dispatch(postDiagnosisCheckEventControlStatus(data));
                } else if (data?.action === "signalStrengthMonitoring") {
                  dispatch(postSignalStrengthQualityEventControlStatus(data));
                } else if (data?.action === "playContent") {
                  dispatch(postPlayContentEventControlStatus(data));
                } else if (data?.action === "viewingTime") {
                  dispatch(viewingTimeFetchNowStatus(data));
                } else if (data?.action === "zapTime") {
                  dispatch(zapTimeFetchNowStatus(data));
                }else if (data?.action === "appUninstall") {
                  dispatch(postUninstallAppsEventControlStatus(data));
                }else if (data?.action === "appKill") {
                  dispatch(postKillAppsEventControlStatus(data));
                }else if (data?.action === "deviceStorage") {
                  dispatch(deviceStorageFetchNowStatus(data));
                }else if (data?.action === "cpuUsage") {
                  dispatch(cpuUsageFetchNowStatus(data));
                }else if (data?.action === "memoryUsage") {
                  dispatch(memoryUsageFetchNowStatus(data));
                }else if (data?.action === "adbEnable") {
                  dispatch(systemDetailsAdbStatus(data));
                }
              // if(data.status==="failed"){
                dispatch(globalControlStatus(data));
              // }
              if(data.status && data.wizardInfo===null){
                if(!location.pathname.includes("wizardStatus")){
                  notify(data)
                }
              }
            },1000)
          }
          // setWebSocketPopup(true);
          // dispatch(globalControlStatus(data));
          // setWebSocketMessage(data);
        }
      }
    }
  };

  // const onRoleChange = (data) =>{
  //   if(data?.userSid==localStorageUserId?.sid){
  //     const selectionFired = new CustomEvent("401_Error", {
  //       "detail": "User Role/Privileges changed! Please login again" });
  //     window.dispatchEvent(selectionFired);
  //   }
  //   else if (data?.roleSid==localStorageUserId?.roles[0].id){
  //     const selectionFired = new CustomEvent("401_Error", {
  //       "detail": "User Role/Privileges changed! Please login again" });
  //     window.dispatchEvent(selectionFired);
  //   }
  // }

  return (
    <Fragment>
      <Switch>
        <Route
          exact
          path="/"
          render={() => {
            if (!localStorage.getItem("jwt_token")) return <Redirect to="/login" />;
            const ws = localStorage.getItem("workspace") || "STB";
            return <Redirect to={ws === "LIT" ? "/lit/dashboard/home" : "/dashboards/home"} />;
          }}
        />

        <Route path="/login" component={Login} />
        <Route path="/forgotPassword" component={ForgotPassword} />
        <Route path="/createpassword" component={CreateNewPassword} />
        <Route path="/signup" component={Signup} />

        {localStorage.getItem("jwt_token") ? (
          <Suspense fallback={<RouteLoader />}>
            {!canAccessRoute ? (
              <PageNotFound />
            ) : (
              <Switch>
                {routes.map((route, index) => (
                  <Route key={index} path={route.path} component={route.component} />
                ))}
                {litRoutes.map((route, index) => (
                  <Route key={`lit-${index}`} path={route.path} component={route.component} />
                ))}
                <Route path="*" component={PageNotFound}/>
              </Switch>
            )}
          </Suspense>
        ) : (
          <Redirect to="/login" />
        )}
      </Switch>
      <ToastContainer className='w-25'/>
      {localStorage.getItem("jwt_token") ? (
        <SockJsClient
          url={`${process.env.REACT_APP_BASE_URL}/stb-ws`}
          topics={[`/topic/fetch-now-msg`]}
          headers={{ Authorization: `Bearer ${localStorage.getItem("jwt_token")}` }}
          autoReconnect={true}
          onMessage={onSocketResponse}
        />
      ) : (
        ""
      )}
      {/* {localStorage.getItem("jwt_token") ? (
        <SockJsClient
          url={`${process.env.REACT_APP_BASE_URL}/stb-ws`}
          topics={[`/topic/privilege-change`]}
          headers={{ Authorization: `Bearer ${localStorage.getItem("jwt_token")}` }}
          autoReconnect={true}
          onMessage={onRoleChange}
        />
      ) : (
        ""
      )} */}
      <Modal
        isOpen={errorFlag}
        footer={{
          secondaryButton: {
            action: () => logout(),
            name: "OK",
            addClass: "btn btn-success px-4",
          },
        }}
      >
        <span className="d-block">
          <img alt="rejected" src="/Images/Rejected.png" style={{ width: 60 }} />
        </span>
        <br />
        <p>{apiMessage}</p>
      </Modal>
      <Modal
        isOpen={errorFlag429}
        footer={{
          secondaryButton: {
            action: () => setErrorFlag429(false),
            name: "OK",
            addClass: "btn btn-success px-4",
          },
        }}
      >
        <span className="d-block">
          <img alt="rejected" src="/Images/Rejected.png" style={{ width: 60 }} />
        </span>
        <br />
        <p>{apiMessage}</p>
      </Modal>
      {/* <Modal
        isOpen={webSocketPopup}
        footer={{
          secondaryButton: {
            action: () => setWebSocketPopup(false),
            name: "OK",
            addClass: "btn btn-success px-4",
          },
        }}
      >
        {webSocketMessage.status === "processed" ? (
          <div>
            <span className="d-block">
              <img alt="approve-qc" src="../Images/approve-qc.png" style={{ width: 60 }} />
            </span>
            <br />
            <p>{`Control Action ${webSocketMessage.action} for SID- ${webSocketMessage.SID} & CDSN- ${webSocketMessage.CDSN} requested by ${webSocketMessage.userName} completed succesfully`}</p>
          </div>
        ) : (
          <div>
            <span className="d-block">
              <img alt="rejected" src="../Images/Rejected.png" style={{ width: 60 }} />
            </span>
            <br />
            <p>{`Control Action ${webSocketMessage.action} for SID- ${webSocketMessage.SID} & CDSN- ${webSocketMessage.CDSN} requested by ${webSocketMessage.userName} failed ! please try again`}</p>
          </div>
        )}
      </Modal> */}
    </Fragment>
  );
};

export default AppMain;
